import templateUrl from "./image-crop.html";

export class ImageCropService {
  constructor(ModalService) {
    "ngInject";

    this.modalService = ModalService;
  }
  typeConfig(type) {
    if (type === "cover") {
      return {
        areaType: "rectangle",
        aspectRatio: 1.7,
        resultImageSize: { w: 340, h: 200 },
      };
    } else if (type === "profile") {
      return {
        areaType: "square",
        aspectRatio: 1,
        resultImageSize: { w: 200, h: 200 },
      };
    } else if (type === "banner") {
      return {
        areaType: "rectangle",
        aspectRatio: 10.7,
        resultImageSize: { w: 2000, h: 90 },
      };
    } else if (type === "tabletAdvertisement") {
      return {
        areaType: "rectangle",
        aspectRatio: 8.1,
        resultImageSize: { w: 730, h: 90 },
      };
    } else if (type === "mobileAdvertisement") {
      return {
        areaType: "rectangle",
        aspectRatio: 3.5,
        resultImageSize: { w: 320, h: 90 },
      };
    }
  }
  cropImage(details) {
    const modalInstane = this.modalService.open({
      details: {
        image: details.image,
        config: this.typeConfig(details.type),
        onCancel: () => {
          modalInstane.dismiss();
          if (details.onCancel) {
            details.onCancel();
          }
        },
        onCrop: (image) => {
          if (details.onCrop) {
            modalInstane.close();
            details.onCrop(image);
          }
        },
        windowClass: details.modal && details.modal.windowClass,
      },
      templateUrl,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/libs/image-crop/image-crop.service.js